module.exports = __webpack_public_path__ + "img/microphone.e17c53af.png";